import { getCookie } from "services/cookies";
import { COOKIES } from "./cookies";

const NODE_ENV = getCookie(COOKIES.NODE_ENV) || process.env.NODE_ENV;

const RAISE_BASE_URL =
  NODE_ENV === "production"
    ? "https://gcx.raise.com"
    : "https://gcx.raisestaging.com";

const GRAPHQL_CMS_BASE_URL = `${RAISE_BASE_URL}/www-cms/graphql`;
const GRAPHQL_PORTAL_URL = `${RAISE_BASE_URL}/portal-api/graphql`;
const RAISE_BFF_URL = `${RAISE_BASE_URL}/support`;
const RAISE_QUERY_URL = `${RAISE_BASE_URL}/query`;
const RAISE_CHECKOUT_URL = `${RAISE_BASE_URL}/checkout`;
const RAISE_API_V1_URL = `${RAISE_BASE_URL}/api/v1`;

export {
  GRAPHQL_CMS_BASE_URL,
  GRAPHQL_PORTAL_URL,
  RAISE_BASE_URL,
  RAISE_BFF_URL,
  RAISE_QUERY_URL,
  RAISE_CHECKOUT_URL,
  RAISE_API_V1_URL
};
